
import { Meeting, Room } from 'api';
import { AppEpic } from 'model';
import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, endWith, filter, map, mergeMap, startWith, withLatestFrom } from 'rxjs/operators';
import APP_MESSAGE from 'constant/message';
import { appMessageError, appMessageSuccess } from 'model/app';
import {
  getAreas, setArea, getRoomWithOrder, setRoomLoadingPending,
  setRoomLoadingRejected, setRoomLoadingFulfilled, signRoom, getOrder,
  setOrder, setRoomList, getRoomDetail, setRoomDetail
} from './index';
import { getMeetingDetailsV2, setMeetingOrderState } from 'model/meeting';

type GetAreaAction = ReturnType<typeof getAreas>
type GetRoomWithOrderAction = ReturnType<typeof getRoomWithOrder>
type SignRoomAction = ReturnType<typeof signRoom>
type GetRoomDetailAction = ReturnType<typeof getRoomDetail>

const getAreaEpic: AppEpic = (action$) => action$.pipe(
  filter(getAreas.match),
  mergeMap(
    () => Room.getAreasV2().pipe(
      map(({ data }) => {
        return setArea(data);
      })
    )
  )
);

const getRoomWithOrderEpic: AppEpic = (action$, state$) => action$.pipe(
  filter(getRoomWithOrder.match),
  withLatestFrom(state$),
  mergeMap(
    ([{ payload }, state]) => Room.getBookRoomV2(payload.params.fetchRoomParams).pipe(
      mergeMap((res) => {
        const roomRes = res.data.data || [];

        // 加载更多时，拼接上历史加载列表
        const roomList = payload.loadMore && state.room.room.data ? {
          ...res.data,
          data: [...state.room.room.data, ...roomRes]
        } : res.data;

        // 执行回调
        payload.onSuccess?.(roomList?.data || []);

        return of(setRoomList(roomList)).pipe(
          endWith(getOrder({
            params: {
              roomIdList: roomRes.map(room => room.id),
              ...payload.params.fetchScheduleParams
            },
            loadMore: payload.loadMore
          }))
        );
      }),
      startWith(setRoomLoadingPending()),
      catchError(() => of(setRoomLoadingRejected()))
    )
  )
);

const getOrderEpic: AppEpic = (action$, state$) => action$.pipe(
  filter(getOrder.match),
  withLatestFrom(state$),
  mergeMap(
    ([{ payload }, state]) => Room.getRoomSchedulesV2(
      {
        ...payload.params,
        roomIdList: payload.params.roomIdList
      }
    ).pipe(
      mergeMap(({ data }) => {
        return of(
          setOrder(payload.loadMore ? [...state.room.orders, ...data] : data),
          setRoomLoadingFulfilled()
        );
      }),
      catchError(() => of(setRoomLoadingRejected()))
    )
  )
);

const signRoomEpic: AppEpic = (action$) => action$.pipe(
  filter(signRoom.match),
  mergeMap(
    (action: SignRoomAction) => Meeting.signMeeting(action.payload).pipe(
      mergeMap(() => of(
        getMeetingDetailsV2(action.payload),
        appMessageSuccess(APP_MESSAGE.ROOM_SIGN_SUCCESS),
        setMeetingOrderState(2)
      )),
      catchError(() => of(appMessageError(APP_MESSAGE.ROOM_SIGN_REJECTED)))
      // startWith(appMessageLoading(APP_MESSAGE.ROOM_SIGN_PENGING)
      // )
    )
  )
);

const getRoomDetailEpic: AppEpic = (action$) => action$.pipe(
  filter(getRoomDetail.match),
  mergeMap(
    (action: GetRoomDetailAction) => Room.getRoomDetailV2(action.payload).pipe(
      mergeMap(({ data }) => of(setRoomDetail(data)))
    )
  )
);

export type RoomEpicActions = GetAreaAction | GetRoomWithOrderAction | SignRoomAction;

export default combineEpics(
  getAreaEpic,
  getRoomWithOrderEpic,
  signRoomEpic,
  getOrderEpic,
  getRoomDetailEpic
);
